import React, { useState } from 'react';
import { Check } from 'lucide-react';

export default function TextInput({ onChoiceClick }) {
  const [text, setText] = useState('');

  const handleDone = () => {
    onChoiceClick(text);
  };

  return (
    <div className="flex flex-col items-center gap-6 w-full max-w-2xl">
      <h2 className="text-2xl md:text-3xl font-semibold text-primary text-center min-h-[40px]">
        Напишите любое осмысленное предложение
      </h2>
      <textarea 
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="w-full h-32 p-4 bg-white rounded-2xl border-2 border-border text-lg focus:outline-none focus:border-accent shadow-inner"
        placeholder="Введите текст..."
      />
      <button 
        onClick={handleDone} 
        className="flex items-center gap-2 px-6 py-3 bg-green-500/20 text-green-600 border-2 border-green-500 rounded-2xl font-semibold hover:bg-green-500/30 transition-colors"
      >
        <Check className="size-5" /> Готово
      </button>
    </div>
  );
}